import { Box, Button, Center } from '@mantine/core';
import { IconCalendarEvent, IconFiles, IconInbox } from '@tabler/icons';
import { FC, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import NavigationLink from '../../../Atoms/Navigation/NavigationLink';
import { useNavigationItem } from '../../../Organismns/Navigation/NavigationItemHook';
import { WindowContext } from '../../../Service/Context/WindowContext';
import { TestS } from '../../../TestS';
import EmailBoxCounter from '../../Emails/EmailBoxCounter';
import { useContactDetails } from '../../../Service/Context/ContactDetailsContext';
import ContactTile from './ContactTile';

const ContactNavBar: FC<{ closeNavBar?: () => void }> = ({ closeNavBar }) => {
  const { id: contactId } = useParams();
  const { removeContact, unreadCount } = useContactDetails();
  const navigate = useNavigate();
  const { sm } = useContext(WindowContext);

  // eslint-disable-next-line no-underscore-dangle
  const _onClick = (path: string) => {
    navigate(path);
    if (closeNavBar) closeNavBar();
  };

  return (
    <>
      {!sm && (
        <Box p="md">
          <ContactTile />
        </Box>
      )}
      <NavigationLink
        variant="filled"
        label="Details"
        onClick={() => _onClick(`/contacts/${contactId}/details`)}
        active={useNavigationItem(`/contacts/${contactId}/details`)}
        icon={sm && <IconCalendarEvent size={16} />}
      />
      <NavigationLink
        variant="filled"
        label="Dateien"
        onClick={() => _onClick(`/contacts/${contactId}/documents`)}
        active={useNavigationItem(`/contacts/${contactId}/documents`)}
        icon={sm && <IconFiles size={16} />}
        testId={TestS.Events.Navigate.TO_DOCUMENTS}
      />
      <NavigationLink defaultOpened label="E-Mails" icon={sm && <IconInbox size={16} />} childrenOffset={28}>
        <NavigationLink
          label="Posteingang"
          active={useNavigationItem(`/contacts/${contactId}/emails/inbox`)}
          onClick={() => _onClick(`/contacts/${contactId}/emails/inbox`)}
          variant="filled"
          rightSection={<EmailBoxCounter count={unreadCount} />}
        />
        <NavigationLink
          label="Entwürfe"
          active={useNavigationItem(`/contacts/${contactId}/emails/drafts`)}
          onClick={() => _onClick(`/contacts/${contactId}/emails/drafts`)}
          variant="filled"
        />
        <NavigationLink
          label="Geplant"
          active={useNavigationItem(`/contacts/${contactId}/emails/scheduled`)}
          onClick={() => _onClick(`/contacts/${contactId}/emails/scheduled`)}
          variant="filled"
        />
        <NavigationLink
          label="Fehlgeschlagen"
          active={useNavigationItem(`/contacts/${contactId}/emails/failed`)}
          onClick={() => _onClick(`/contacts/${contactId}/emails/failed`)}
          variant="filled"
          // rightSection={<EmailBoxCounter count={failedCount} />}
        />
        <NavigationLink
          label="Gesendet"
          active={useNavigationItem(`/contacts/${contactId}/emails/outbound`)}
          onClick={() => _onClick(`/contacts/${contactId}/emails/outbound`)}
          variant="filled"
        />
        <NavigationLink
          label="Papierkorb"
          active={useNavigationItem(`/contacts/${contactId}/emails/trash`)}
          onClick={() => _onClick(`/contacts/${contactId}/emails/trash`)}
          variant="filled"
        />
      </NavigationLink>

      <Center>
        <Box sx={{ position: 'absolute', bottom: 20 }}>
          <Button
            color="red"
            variant="subtle"
            onClick={() => {
              if (closeNavBar) closeNavBar();
              removeContact();
            }}
          >
            Kontakt löschen
          </Button>
        </Box>
      </Center>
    </>
  );
};

export default ContactNavBar;
